import { useEffect, useState } from "react";
import { CardTaps } from "../theme/Component/CardTaps";
import { PrintJson } from "../theme/Component/PrintJson";
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../theme/Component/BasicTable";
import { Modal } from "../theme/Component/Modal";
import useModal, { MODAL_XL } from "../theme/Component/hooks/useModal";
import { VisorDocumentFactory } from "../documents/VisorDocumentFactory";

interface Props{
    year:number;
    row:any;
}
export const ViewBudgetDocuments=({year,row}:Props)=>{


    const [list,setList] = useState<any>([]);
    const [bean,setBean] = useState<any>({});
    const [indexTap, setIndexTap] = useState(0);
    const modalDocument = useModal("Documento",MODAL_XL);
     let taps = [
        { id: 0, name: 'CDP', disable: false },
        { id: 1, name: 'RCDP', disable: false },
        { id: 2, name: 'RP', disable: false },
        { id: 3, name: 'RRP', disable: false },
        { id: 4, name: 'OB', disable: false },
        { id: 5, name: 'CE', disable: false },
    ];

    const loadList=()=>{
        
        switch(indexTap)
        {
            case 0:
                setList([{
                    DataBeanProperties:{
                        IDDocument:row.IDDocument,
                        Consecutive:row.Consecutive,
                        DocumentDate:row.DocumentDate,
                        Mnemonic:row.Mnemonic,
                        Value:row.Value
                    }
                }])
            break;
            case 1:
                setList(row.RCDPDocuments);
            break;
            case 2:
                setList(row.RPDocuments);
            break;
            case 3:
                setList(row.RRPDocuments);
            break;
            case 4:
                setList(row.OBDocuments);
            break;
            case 5:
                row.CEDocuments.forEach(element => {
                    
                    element.DataBeanProperties.Consecutive = element.DataBeanProperties.CEConsecutive;
                    element.DataBeanProperties.Mnemonic = element.DataBeanProperties.CEMnemonic;
                    element.DataBeanProperties.IDDocument = element.DataBeanProperties.CEIDDocument;
                    element.DataBeanProperties.DocumentDate = element.DataBeanProperties.CEDate;
                });
                setList(row.CEDocuments);
                
            break;
            default :
            setList([]);
            break;

        }
        
    }

    useEffect(()=>{
        loadList();
    },[indexTap])

    const openDocument = (row)=>{
        setBean(row);
        modalDocument.open();
    }

    const head = [
         { title: 'ID', property: 'IDDocument', visible: false,mask:MASK_NUMBER },
        { title: 'Tipo Documento', property: 'Mnemonic', visible: true },
        { title: 'Consecutivo', property: 'Consecutive', visible: true,mask:MASK_NUMBER },
        { title: 'Valor', property: 'Value', visible: true,mask:MASK_MONEY },
        { title: 'Fecha', property: 'DocumentDate', visible: true },
    ]

    return(
        <div className="row">
            <div className="col-md-12">
                <CardTaps index={indexTap} updateIndex={setIndexTap} taps={taps}>
                    <div className="row">
                        <div className="col-md-12">                            
                            <BasicTable body={list} head={head} rowSet={(e)=>{openDocument(e)}}></BasicTable>                            
                            <Modal modal={modalDocument.modal} updateModal={modalDocument.setModal}>
                                <VisorDocumentFactory Year={year} Mnemonic={bean.Mnemonic} Consecutive={bean.Consecutive}/>
                            </Modal>
                        </div>
                    </div>

                </CardTaps>
            </div>
           
        </div>
    )
}